import React from 'react';
import { useParams } from 'react-router-dom';
import AlgorithmicProblemView from './AlgorithmicProblemView';
import { PracticeWidget } from '../Practice';
import PageContainer from '../layout/PageContainer';

const AlgorithmicProblemDetail = () => {
    const { id } = useParams();

    return (
        <PageContainer>
            <AlgorithmicProblemView problemId={id} />
            <PracticeWidget 
                contentType="AlgorithmicProblem" 
                contentId={id} 
            />
        </PageContainer>
    );
};

export default AlgorithmicProblemDetail;
